<div  *ngIf="!load"class="card mb-4">
  <div class="card-body">

      <div class="text-muted small">
        <span>Borderôs cadastrados pelo cliente <strong>Online</strong></span>
      </div>
  </div>

  <div class="px-2">
    <div class="w-100">
     <ol class="list-group list-group-numbered mb-3">
      <li class="list-group-item d-flex justify-content-between align-items-start" *ngFor="let bordero of borderos">
        <div class="ms-2 me-auto">
          <div class="user"><strong>Credor: </strong>{{bordero.credor}}</div>
          <div class="user"><strong>Borderô: </strong>{{bordero.arquivo}}</div>
          <div class="user"><strong>Data do cadastro: </strong>{{bordero.dataHora | date: 'fullDate'}}</div>
          <div><strong>Hora do cadastro: </strong>{{bordero.dataHora | date: 'hh:mm a'}}</div>
        </div>
      </li>
    </ol>
    </div>
  </div>

</div>

<div *ngIf="load" class="card mb-4" style="display: flex;flex-direction: column;justify-content: center;align-items: center">

  <div class="card-body">

  </div>

  <div class="card-body">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>

  <div class="card-body">
  </div>

</div>
